import { render } from "./TestDrivePage.vue?vue&type=template&id=fe5e4dc2"
import script from "./TestDrivePage.vue?vue&type=script&lang=js"
export * from "./TestDrivePage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__